export function createSocialCardsTags(details) {
  return [
    { hid: 'description', name: 'description', content: details.description },
    { hid: 'og:type', property: 'og:type', content: 'website' },
    { hid: 'og:url', property: 'og:url', content: details.pageUrl },
    { hid: 'og:title', property: 'og:title', content: details.title },
    { hid: 'og:description', property: 'og:description', content: details.description },
    { hid: 'og:image', property: 'og:image', content: details.imageSrc },
    { hid: 'twitter:url', name: 'twitter:url', content: details.pageUrl },
    { hid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' },
    { hid: 'twitter:description', name: 'twitter:description', content: details.description },
    { hid: 'twitter:title', name: 'twitter:title', content: details.title },
    { hid: 'twitter:image', name: 'twitter:image', content: details.imageSrc },
    { hid: 'twitter:site', name: 'twitter:site', content: '@joinfightcamp' },
    { hid: 'twitter:creator', name: 'twitter:creator', content: '@joinfightcamp' },
  ];
}
